import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModels = [
  {
    class: 'ineligible',
    field: 'unisexHairLoss_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    blockQuestionFlow: true,
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    field: 'unisexHairLoss_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'unisexHairLoss_sexAssignedAtBirth',
    extras: {
      sendToBeluga: true,
      mapToBelugaField: 'sex'
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'unisexHairLoss_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'Do you have any of the following? (check all that apply):',
    field: 'unisexHairLoss_maleConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'unisexHairLoss_maleConditions_prostateCancer',
          value: 'Current or personal history of prostate cancer'
        },
        {
          key: 'unisexHairLoss_maleConditions_familyProstateCancer',
          value: 'Strong family history of prostate cancer'
        },
        {
          key: 'unisexHairLoss_maleConditions_erectileDysfunction',
          value: 'Erectile Dysfunction'
        },
        {
          key: 'unisexHairLoss_maleConditions_decreasedLibido',
          value: 'Decreased libido'
        },
        {
          key: 'unisexHairLoss_maleConditions_none',
          value: 'None of these apply',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label:
      'Are you postmenopausal, meaning you have not had a menstrual period for 12 months or longer or have had a surgical resection of both of your ovaries and/or uterus?',
    field: 'unisexHairLoss_postmenopausal',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_postmenopausal_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_postmenopausal_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'unisexHairLoss_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_pregnancy_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_pregnancy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Consent (Pregnancy)',
    educationalSlide: `I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. For example, medications which contain finasteride are known to cause significant birth defects in a fetus and child. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.

I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.

I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.

By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
    field: 'unisexHairLoss_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_pregnancyConsent_disagree',
          class: 'option-decline',
          value: 'I have read the information and do NOT wish to proceed'
        },
        {
          key: 'unisexHairLoss_pregnancyConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'unisexHairLoss_height',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'unisexHairLoss_weight',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'Which areas are affected by hair loss?',
    field: 'unisexHairLoss_affectedAreas',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'unisexHairLoss_affectedAreas_receding',
          value: 'Receding hairline (frontal)'
        },
        {
          key: 'unisexHairLoss_affectedAreas_crown',
          value: 'Thinning at the crown'
        },
        {
          key: 'unisexHairLoss_affectedAreas_sides',
          value: 'Thinning on the sides'
        },
        {
          key: 'unisexHairLoss_affectedAreas_overall',
          value: 'Overall thinning'
        },
        {
          key: 'unisexHairLoss_affectedAreas_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Tell us more about the pattern of your hair loss',
    field: 'unisexHairLoss_hairLossPattern',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_hairLossPattern',
      type: 'text',
      placeholder: 'Describe your hair loss pattern'
    }
  },
  {
    label: 'How long have you been experiencing hair loss?',
    field: 'unisexHairLoss_duration',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_duration_lessThan6',
          value: 'Less than 6 months'
        },
        {
          key: 'unisexHairLoss_duration_6to12',
          value: '6 months to 1 year'
        },
        {
          key: 'unisexHairLoss_duration_over1Year',
          value: 'Over 1 year'
        }
      ]
    }
  },
  // The following 3 questions (extent, cause, causeDetails) have been removed
  // as per CRM-2085 (Thare Health update). They remain here so historical
  // consultations can still render properly.
  {
    label: 'How much hair have you lost?',
    field: 'unisexHairLoss_extent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_extent_little',
          value: 'A little (Only I notice it)'
        },
        {
          key: 'unisexHairLoss_extent_some',
          value: 'Some (Those close to me notice it)'
        },
        {
          key: 'unisexHairLoss_extent_lot',
          value: 'A lot (It is obvious to everyone)'
        }
      ]
    }
  },
  {
    label: 'Do you believe your hair loss is due to:',
    field: 'unisexHairLoss_cause',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'unisexHairLoss_cause_genetics',
          value: 'Genetics'
        },
        {
          key: 'unisexHairLoss_cause_stress',
          value: 'Stress'
        },
        {
          key: 'unisexHairLoss_cause_medicalConditions',
          value: 'Medical conditions'
        },
        {
          key: 'unisexHairLoss_cause_medications',
          value: 'Medications'
        },
        {
          key: 'unisexHairLoss_cause_nutritional',
          value: 'Nutritional deficiencies'
        },
        {
          key: 'unisexHairLoss_cause_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: "Tell us more about why you think you're losing hair",
    field: 'unisexHairLoss_causeDetails',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_causeDetails',
      type: 'text',
      placeholder: 'Describe the cause of your hair loss'
    }
  },
  {
    label: 'Have you ever had your hair loss evaluated by a physician?',
    field: 'unisexHairLoss_evaluatedByPhysician',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_evaluatedByPhysician_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_evaluatedByPhysician_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please select any of the following diagnoses that you have been given by a physician in the past',
    field: 'unisexHairLoss_diagnosis',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'unisexHairLoss_diagnosis_androgenetic',
          value: 'Androgenetic alopecia'
        },
        {
          key: 'unisexHairLoss_diagnosis_alopeciaAreata',
          value: 'Alopecia areata'
        },
        {
          key: 'unisexHairLoss_diagnosis_traction',
          value: 'Traction alopecia'
        },
        {
          key: 'unisexHairLoss_diagnosis_telogen',
          value: 'Telogen effluvium'
        },
        {
          key: 'unisexHairLoss_diagnosis_discoidLupus',
          value: 'Discoid Lupus'
        },
        {
          key: 'unisexHairLoss_diagnosis_scarring',
          value: 'Scarring Alopecia'
        },
        {
          key: 'unisexHairLoss_diagnosis_frontalFibrosing',
          value: 'Frontal Fibrosing Alopecia'
        },
        {
          key: 'unisexHairLoss_diagnosis_other',
          value: 'Other hair loss diagnosis'
        },
        {
          key: 'unisexHairLoss_diagnosis_none',
          value: 'I have not been given a diagnosis',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your diagnosis',
    field: 'unisexHairLoss_diagnosisDetails',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_diagnosisDetails',
      type: 'text',
      placeholder: 'Describe your diagnosis'
    }
  },
  {
    label:
      'Do you have any scalp conditions such as psoriasis, dermatitis, and/or recent or current scalp infections?',
    field: 'unisexHairLoss_scalpConditions',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_scalpConditions_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_scalpConditions_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have excessive dandruff, scalp irritation, scalp redness, burning, pustules, or scarring?',
    field: 'unisexHairLoss_scalpIrritation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_scalpIrritation_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_scalpIrritation_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you losing hair in different parts of your body?',
    field: 'unisexHairLoss_bodyHairLoss',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_bodyHairLoss_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_bodyHairLoss_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Tell us more about your hair loss in other parts of your body',
    field: 'unisexHairLoss_bodyHairLossDetails',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_bodyHairLossDetails',
      type: 'text',
      placeholder: 'Describe hair loss in other body parts'
    }
  },
  {
    label: 'Have you tried any treatments for hair loss before?',
    field: 'unisexHairLoss_previousTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_previousTreatment_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_previousTreatment_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Tell us more about your previous treatment including product use, when, duration of use, and did you experience side effects?',
    field: 'unisexHairLoss_previousTreatmentDetails',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_previousTreatmentDetails',
      type: 'text',
      placeholder: 'Describe your previous treatments'
    }
  },
  {
    label:
      'Do you have any of the following medical conditions? (check all that apply)',
    field: 'unisexHairLoss_medicalConditionsSpecific',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'unisexHairLoss_medicalConditionsSpecific_liver',
          value: 'Liver disease such as liver cirrhosis'
        },
        {
          key: 'unisexHairLoss_medicalConditionsSpecific_kidney',
          value:
            'Kidney disease such as chronic kidney disease or kidney failure'
        },
        {
          key: 'unisexHairLoss_medicalConditionsSpecific_heart',
          value: 'Heart conditions or cardiovascular diseases'
        },
        {
          key: 'unisexHairLoss_medicalConditionsSpecific_stroke',
          value: 'History of stroke'
        },
        {
          key: 'unisexHairLoss_medicalConditionsSpecific_pheochromocytoma',
          value: 'Pheochromocytoma (adrenal gland tumor)'
        },
        {
          key: 'unisexHairLoss_medicalConditionsSpecific_pulmonary',
          value: 'Pulmonary hypertension'
        },
        {
          key: 'unisexHairLoss_medicalConditionsSpecific_none',
          value: 'None of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label:
      'Do you have a history of depression, bipolar disorder, anxiety, or other mood disorders?',
    field: 'unisexHairLoss_moodDisorders',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_moodDisorders_yes',
          value: 'Yes'
        },
        {
          key: 'unisexHairLoss_moodDisorders_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Can you tell us more about your mood disorder and whether it is controlled or uncontrolled?',
    field: 'unisexHairLoss_moodDisordersDetails',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_moodDisordersDetails',
      type: 'text',
      placeholder: 'Describe your mood disorder'
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'unisexHairLoss_additionalInfo',
    type: 'info',
    answer: {
      name: 'unisexHairLoss_additionalInfo',
      type: 'text',
      placeholder: 'Additional information or questions'
    }
  },
  {
    label: 'Consent (Truthfulness)',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.

Consent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    field: 'unisexHairLoss_truthfulnessConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_truthfulnessConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do not wish to continue'
        },
        {
          key: 'unisexHairLoss_truthfulnessConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information and I do consent and wish to move forward'
        }
      ]
    }
  },
  {
    label: 'Consent (Hair Loss Treatment)',
    educationalSlide: `Please read the following information to learn more about risks and potential side effects to treatment.

Purpose of Treatment
This consent applies to various medical interventions aimed at addressing hair loss in males and females. These treatments focus on slowing hair loss, stimulating new hair growth, and improving hair density and appearance. Given states restrictions, some of these products may not be offered in your area.

Treatment Options
- Finasteride: An oral medication that inhibits the conversion of testosterone to dihydrotestosterone (DHT), a hormone linked to hair loss. It helps slow hair loss and may promote regrowth. This is only available for men and post-menopausal females given birth defect risk
- Minoxidil: A topical solution that stimulates hair follicles to promote hair growth by increasing blood flow to the scalp.
- GUK-Cu: A copper peptide complex believed to enhance blood flow, support scalp health, and promote hair growth.
- Other treatments as discussed with your healthcare provider including combinations of anti-inflammatory products, caffeine derivatives, and antihistamines

Potential Benefits
- Slowing the progression of hair loss
- Stimulating new hair growth
- Enhancing the thickness and appearance of existing hair
- Improving self-esteem and quality of life

Contraindications
Certain treatments may not be suitable for individuals with:
Finasteride:
   - Liver disease
   - History of prostate cancer
   - Allergies to finasteride or its components
   - Women who are or may become pregnant (should not handle finasteride tablets as there is a risk for birth defects)
Minoxidil:
   - Scalp conditions (e.g., dermatitis, psoriasis)
   - Allergies to minoxidil or its components
GUK-Cu:
   - Allergies to copper peptides or its components
General:
   - Pregnancy or breastfeeding as certain products can cause severe birth defects
   - Hormonal imbalances
   - Scalp conditions or allergies to other medications or components

Potential Risks and Side Effects
Finasteride:
   - Sexual dysfunction (decreased libido, erectile dysfunction)
   - Breast tenderness or enlargement
   - Depression or mood changes
   - Allergic reactions
   - Possible effect on PSA levels used in prostate cancer screening
   - Severe birth defect risk when used during pregnancy
Minoxidil:
   - Scalp irritation, itching, or dryness
   - Unwanted facial or body hair growth
   - Changes in blood pressure or heart rate (rare)
GUK-Cu:
   - Scalp irritation
   - Allergic reactions
General Risks:
   - Hormonal changes
   - Electrolyte imbalances
   - Mood changes or depression

Monitoring and Follow-Up
Regular monitoring is recommended to assess effectiveness and detect any side effects. Inform your provider of any adverse reactions or concerns.

Alternative Treatments
- Hair transplant surgery
- Low-level laser therapy
- Platelet-rich plasma (PRP) therapy
- Lifestyle adjustments and acceptance of hair loss

Patient Responsibilities
- Use treatments exactly as prescribed
- Report any side effects promptly
- Keep all follow-up appointments
- Inform your provider of any changes in your health status or medications

By agreeing below, you acknowledge that you have read and understood the information provided in this consent form. You agree to proceed with treatment under the conditions outlined above.`,
    field: 'unisexHairLoss_treatmentConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'unisexHairLoss_treatmentConsent_disagree',
          class: 'option-decline',
          value: 'I have read the above information and do NOT wish to proceed.'
        },
        {
          key: 'unisexHairLoss_treatmentConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information, understand the risks, and wish to proceed.'
        }
      ]
    }
  },
  {
    label: `Consent for Male Topical Hair Loss Treatment`,
    educationalSlide: `This medication is used to help treat male-pattern hair loss by supporting scalp health, slowing hair loss, and potentially improving hair thickness and density over time. Hair growth is gradual and may take several months of consistent use before noticeable improvement occurs. Temporary increased shedding may occur early in treatment as hair follicles transition through the growth cycle.

Medication Components and Potential Benefit:
- Minoxidil may help stimulate hair follicles and support hair growth. This compounded formula contains 8% minoxidil, which is stronger than many over-the-counter formulations.
- Dutasteride helps reduce the conversion of testosterone to dihydrotestosterone (DHT), a hormone associated with male-pattern hair loss. Use of topical dutasteride for hair loss is off-label and may still carry some systemic risks.
- Cetirizine is an antihistamine included for its potential anti-inflammatory effects on the scalp.
- Caffeine is included to support scalp and follicle stimulation.
- Melatonin is included for its potential role in supporting the hair growth cycle.
This is a compounded medication and is not FDA-approved as a combined product for hair loss. Your provider has determined that this may be appropriate based on your individual medical history and treatment goals. Benefits are not guaranteed, and continued use is required to maintain results.

Do not use this medication if you:
- Are female, pregnant, trying to become pregnant, or breastfeeding
- Have a known allergy to minoxidil, dutasteride, cetirizine, caffeine, melatonin, or any ingredient in the medication
- Have an infected, inflamed, irritated, sunburned, or broken scalp in the area of application
- Have hair loss associated with scalp pain, scaling, infection, or rash unless evaluated by a healthcare provider
- Have a history of significant reaction to topical hair loss products
- Have been advised by a clinician not to use minoxidil or 5-alpha-reductase inhibitors

Pregnancy and Exposure Warning:
This medication contains dutasteride, which may cause harm to a developing male fetus. This medication should not be used or handled by anyone who is pregnant, may become pregnant, or is breastfeeding. After applying the medication, wash your hands thoroughly. Do not allow pregnant individuals, children, or others to touch the medication or treated scalp until it has fully dried. Keep the medication securely stored away from children and pets.

Possible side effects include:
- Scalp irritation, itching, burning, redness, dryness, flaking, or rash
- Contact dermatitis or allergic reaction
- Temporary increased hair shedding early in treatment
- Unwanted facial or body hair growth if the medication spreads beyond the scalp
- Headache or dizziness
- Greasy or sticky hair/scalp residue
- Eye irritation if the medication accidentally contacts the eyes

Less common but potentially serious side effects may include:
- Chest pain
- Rapid heartbeat or palpitations
- Lightheadedness, fainting, or dizziness
- Sudden unexplained weight gain
- Swelling of the hands, feet, face, or ankles
- Shortness of breath
- Severe scalp irritation, blistering, or skin reaction

Because this medication contains dutasteride, possible hormonal or systemic side effects may occur (though risk is significantly lower with a topical preparation). These include:
- Decreased libido
- Erectile dysfunction
- Ejaculatory changes
- Testicular discomfort
- Breast tenderness or enlargement
- Mood changes or depression
- Changes in fertility parameters
- Possible effect on PSA levels used in prostate cancer screening

Some sexual, mood, breast, or hormonal side effects have been reported to persist after stopping 5-alpha-reductase inhibitor medications, although this is uncommon. Dutasteride may lower PSA levels, which can affect interpretation of prostate cancer screening. Tell any healthcare provider who orders or reviews your PSA test that you are using a dutasteride-containing medication, even if it is topical.

Use this medication exactly as prescribed. General precautions:
- Apply only to the scalp area directed by your provider.
- Do not apply to broken, irritated, infected, or inflamed skin.
- Avoid contact with the eyes, mouth, genitals, or other sensitive areas.
- Wash your hands after use.
- Allow the medication to dry before lying down, wearing a hat, or allowing others to touch the treated area.
- Do not use more than prescribed, as this may increase the risk of systemic absorption and side effects.
- Do not combine with other hair loss treatments unless directed by your healthcare provider.

Hair growth treatment requires consistency. If treatment is stopped, any hair growth benefit may gradually be lost.

Alternative options may include:
- Over-the-counter topical minoxidil
- Oral medications such as finasteride or dutasteride (if clinically appropriate)
- Low-level laser therapy
- Platelet-rich plasma therapy
- Hair transplant surgery
- Cosmetic approaches such as hair fibers, scalp micropigmentation, or hairpieces
- No treatment or acceptance of natural hair loss

By agreeing below, you acknowledge that you have read and understood the information provided in this consent form. You agree to proceed with treatment under the conditions outlined above.`,

    field: 'unisexHairLoss_thare_treatmentConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'disagree',
          class: 'option-decline',
          value: 'I have read the above information and do NOT wish to proceed.'
        },
        {
          key: 'agree',
          class: 'option-consent',
          value:
            'I have read the above information, understand the risks, and wish to proceed.'
        }
      ]
    }
  }
] as const;

const _type = questionsModels;
export type UnisexHairlossQuestionAnswerFields = Partial<
  QuestionAnswerMap<typeof _type>
>;

export default questionsModels;
